/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { TimeInterval } from './types';
import { MAGIC_VALUE } from './Constants';

export const determineInterval = (numOfDays: number) => {
  return numOfDays <= MAGIC_VALUE.THIRTYONE
    ? TimeInterval.Monthly
    : numOfDays <= MAGIC_VALUE.NINETYTWO
    ? TimeInterval.ThreeMonths
    : TimeInterval.Yearly;
};

export const determineIntervalEnergyUsage = (numOfDays: number) => {
  return numOfDays <= 1 ? TimeInterval.Hourly : TimeInterval.Daily;
};
